import {
  ButtonWrapper, 
  AddressWrapperDiv, 
  HeaderTitleDiv, 
  HeaderDiv, 
  HeaderIconImg,
  KioskHeaderDiv,
  KioskHeaderTitleDiv,
  KioskButtonWrapper
} from './styled-components';

export {
  ButtonWrapper,
  AddressWrapperDiv,
  HeaderTitleDiv,
  HeaderDiv,
  HeaderIconImg,
  KioskHeaderDiv,
  KioskHeaderTitleDiv,
  KioskButtonWrapper
};



// WEBPACK FOOTER //
// ./src/pages/index.js